import $ from 'jquery';
const isScrolledIntoView = (elem)=>{
    var _$, _$_offset;
    const $window = $(window);
    if (!$window || !$window.height || !((_$ = $(elem)) === null || _$ === void 0 ? void 0 : _$.height)) {
        return false;
    }
    const docViewTop = $window.scrollTop() || 0;
    const windowHeight = $window.height() || 0;
    const docViewBottom = docViewTop + windowHeight;
    const elemTop = ((_$_offset = $(elem).offset()) === null || _$_offset === void 0 ? void 0 : _$_offset.top) || 0;
    const elemHeight = $(elem).height() || 0;
    const elemBottom = elemTop + elemHeight;
    return elemBottom <= docViewBottom && elemTop >= docViewTop;
};
export const init = async function() {
    const body = $('body');
    const announcementBar = document.querySelector('.js-announcement-bar');
    $(window).on('scroll', function() {
        const $window = $(window);
        if (!$window || !$window.height || !announcementBar) {
            return;
        }
        if (isScrolledIntoView(announcementBar)) {
            body.removeClass('promo-bar-hidden');
        } else {
            body.addClass('promo-bar-hidden');
        }
    });
};
